import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Section from 'components/Section';
import NavigationButtons from 'components/NavigationButtons';
import i18n from 'utils/translate';
import RadioButtonGroup from '../../../../components/RadioButtonGroup';
import { formatPrice } from 'utils/common';
import { animateScroll } from 'react-scroll';
import './styles.scss';
import { paymentDetails } from '../../utils';
import { PAYMENT_TYPE_ANNUAL } from '../../constants';
import { linkTypeShape } from 'utils/types';

const propTypes = {
  backLink: PropTypes.shape(linkTypeShape),
  nextLink: PropTypes.shape(linkTypeShape).isRequired,
  onChange: PropTypes.func.isRequired,
  renderSummaryBox: PropTypes.any
};

const defaultProps = { data: {} };

class RiskDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      risikoAbgelehnt: null,
      risikoSchaeden: null,
      ...props.data,
      submitted: false,
      validForm: false
    };
  }

  componentDidMount() {
    animateScroll.scrollToTop({ duration: 0 });
  }

  handleSubmit = e => {
    const {
      nextLink: { go } = {
        go: () => {}
      },
      onChange = () => {}
    } = this.props;
    const form = this.refs.form;

    if (form.checkValidity && !form.checkValidity() && this.validRisk()) {
      form.reportValidity();
      return;
    }

    onChange(this.state);
    go();

    window.dataLayer.push({
      event: 'onlineabschluss',
      formname: 'Sachverständiger- und Dolmetsch-Versicherung',
      action: 'Schritt 3 von 5'
    });
  };

  handleDataChange = (data, key) => {
    const { onChange } = this.props;
    this.setState({ [`${key}`]: data }, () => {
      onChange(this.state);
    });
  };

  invalidRiskError = (
    <div>
      {i18n(
        'Unter diesen Umständen ist kein Online-Abschluss möglich. Bitte wenden Sie sich an die Abteilung VH-UHR unter 0316/8037-6228 oder '
      )}
      <a href="mailto:center.gd.vuhr@grawe.at">center.gd.vuhr@grawe.at</a>.
    </div>
  );

  validRisk = () => {
    const { risikoAbgelehnt, risikoSchaeden } = this.state;

    const wasDeclined = risikoAbgelehnt === null || risikoAbgelehnt;
    const hadDamage = risikoSchaeden === null || risikoSchaeden;

    return !wasDeclined && !hadDamage;
  };

  render() {
    const { risikoAbgelehnt, risikoSchaeden, submitted } = this.state;
    const {
      backLink,
      quote,
      quote: { price, currency, paymentVariants },
      paymentInterval,
      renderSummaryBox
    } = this.props;

    return (
      <div className="row">
        <form
          ref="form"
          onSubmit={this.handleSubmit}
          className={`page-step-wrapper col-md-8 risk-details page-step-wrapper--narrow ${
            submitted ? 'submitted' : ''
          }`}
          id="insurance-form"
        >
          <Section header={i18n('Wurde Ihnen das beantragte Risiko bereits einmal gekündigt oder abgelehnt?')}>
            <RadioButtonGroup
              required={true}
              ref="risikoAbgelehnt"
              value={risikoAbgelehnt}
              id="declined"
              useGrid={true}
              customError={this.invalidRiskError}
              onChange={data => this.handleDataChange(data, 'risikoAbgelehnt')}
              options={[
                { label: 'Nein ', value: false },
                { label: 'Ja ', value: true, valid: false }
              ]}
            />
          </Section>

          <Section
            header={i18n(
              'Gab es in der Vergangenheit Schäden aus dem Haftpflichtrisiko Ihrer Sachverständigen-/Dolmetscher-Tätigkeit?'
            )}
          >
            <RadioButtonGroup
              required={true}
              ref="risikoSchaeden"
              value={risikoSchaeden}
              id="damaged"
              useGrid={true}
              customError={this.invalidRiskError}
              onChange={data => this.handleDataChange(data, 'risikoSchaeden')}
              options={[
                { label: 'Nein', value: false },
                { label: 'Ja', value: true, valid: false }
              ]}
            />
          </Section>

          <div className="sticky-footer">
            <div className="page-step-wrapper__price d-md-none">
              {i18n('Prämie (jährlich)')}&nbsp;
              {formatPrice(price, currency)}
              {paymentInterval !== PAYMENT_TYPE_ANNUAL && !!paymentVariants && paymentDetails(paymentInterval, quote)}
            </div>
            <NavigationButtons
              backLink={backLink}
              nextLink={{
                go: e => {
                  this.setState({
                    submitted: true,
                    validForm: this.refs.form.checkValidity && this.refs.form.checkValidity() && this.validRisk()
                  });

                  Object.keys(this.refs).forEach(key => {
                    if (this.refs[key].onBlur) {
                      this.refs[key].onBlur();
                    }
                  });

                  if (this.refs.form.checkValidity && this.refs.form.checkValidity() && this.validRisk()) {
                    this.handleSubmit();
                  }
                }
              }}
            />
          </div>
        </form>
        <div className="summary-wrapper col-md-4">{renderSummaryBox}</div>
      </div>
    );
  }
}

RiskDetails.defaultProps = defaultProps;
RiskDetails.propTypes = propTypes;

export default RiskDetails;
